import React from 'react';
import { FORM_TYPES } from 'Interfaces/LoginRegisterFormProps';
import { getCookie } from 'SharedHelpers/cookieHelper';

interface HiddenFieldsInterface {
    usingRef: Function;
    redirectUrl: string;
    isLogin: boolean;
    isReferral: boolean;
    isClubMf: boolean;
}

const HiddenFields: React.FunctionComponent<HiddenFieldsInterface> = ({
    usingRef,
    redirectUrl,
    isClubMf,
    isLogin,
    isReferral,
}): JSX.Element => {
    const csrfToken = decodeURIComponent(getCookie('YII_CSRF_TOKEN'));

    const hiddenFields = [
        { name: 'type', value: 'email_and_password' },
        { name: 'pagetype', value: 'pagetype' },
        { name: 'redirectUrl', value: redirectUrl },
        { name: 'login', value: isLogin ? '1' : '0' },
        { name: 'YII_CSRF_TOKEN', value: csrfToken === '' ? '1' : csrfToken },
    ];

    // todo cleanup when the cup is ready https://westwing.jira.com/browse/CLUBSTYLE-1680
    if (isClubMf) {
        hiddenFields.push({ name: 'nd', value: '1' });
    }

    if (isReferral) {
        hiddenFields.push({ name: 'isReferral', value: '1' });
    }

    if (!isLogin) {
        hiddenFields.push({ name: 'formType', value: FORM_TYPES.SHARED_SIGNUP_FORM });
    }

    return (
        <>
            {hiddenFields.map(field => (
                <input key={field.name} type="hidden" name={field.name} value={field.value} ref={usingRef()} />
            ))}
        </>
    );
};

export default HiddenFields;
